import { AxiosResponse } from "axios";
import http from "@/axios/http-common";
import { appModule } from "@/store/modules/app";
import {
  JenisResumeCetak,
  PeruntukanCetakResume,
  PermintaanCetakUlang,
  StatusCetakResume
} from "@/types/resume_cetak";

const ALAMAT_RESUME: Record<JenisResumeCetak, string> = {
  ranap: "/resume-ranap"
};

export const NAMA_DOKUMEN_RESUME: Record<JenisResumeCetak, string> = {
  ranap: "Ringkasan Pulang"
};

const PDF_REQUEST_CONFIG = {
  responseType: "blob",
  validateStatus: (status: number) => status !== 401 && status < 500
};

function bacaTeksBlob(data: Blob): Promise<string> {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => resolve("");
    reader.readAsText(data);
  });
}

async function pesanGagalPdf(
  jenis: JenisResumeCetak,
  data: unknown,
  status: number
): Promise<string> {
  const pesanBawaan = `Gagal memuat PDF ${NAMA_DOKUMEN_RESUME[jenis]} (HTTP ${status})`;

  if (!(data instanceof Blob)) {
    return pesanBawaan;
  }

  try {
    const isi = JSON.parse(await bacaTeksBlob(data));

    return isi?.message || pesanBawaan;
  } catch (e) {
    return pesanBawaan;
  }
}

async function urlPdf(
  jenis: JenisResumeCetak,
  request: Promise<AxiosResponse>
): Promise<string> {
  const response = await request;

  if (response.status !== 200) {
    const pesan = await pesanGagalPdf(jenis, response.data, response.status);
    appModule.sendErrorAlert(pesan);

    return Promise.reject(new Error(pesan));
  }

  return URL.createObjectURL(
    new Blob([response.data as BlobPart], { type: "application/pdf" })
  );
}

function pratinjau(
  jenis: JenisResumeCetak,
  id: number | string
): Promise<string> {
  return urlPdf(
    jenis,
    http.getDataParam(`${ALAMAT_RESUME[jenis]}/${id}/pdf`, PDF_REQUEST_CONFIG)
  );
}

async function cetak(
  jenis: JenisResumeCetak,
  id: number | string,
  peruntukan: PeruntukanCetakResume,
  cetakUlang: PermintaanCetakUlang | null = null
): Promise<void> {
  const tab = window.open("", "_blank");

  try {
    const url = await urlPdf(
      jenis,
      http.postData(
        `${ALAMAT_RESUME[jenis]}/${id}/cetak`,
        { peruntukan, ...(cetakUlang || {}) },
        PDF_REQUEST_CONFIG
      )
    );

    if (tab) {
      tab.location.href = url;
    } else {
      window.open(url, "_blank");
    }

    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (tab) {
      tab.close();
    }

    return Promise.reject(err);
  }
}

async function statusCetak(
  jenis: JenisResumeCetak,
  id: number | string
): Promise<StatusCetakResume> {
  const response = await http.getData(`${ALAMAT_RESUME[jenis]}/${id}/cetak`);

  return response.data as StatusCetakResume;
}

export default {
  pratinjau,
  cetak,
  statusCetak
};
